// removed by extract-text-webpack-plugin
module.exports = {"formLabelInlineGroup":"_2dguJ","formResponse":"_3A0tk","formLabel":"pPbJN","captcha":"_3L08L"};